import React from 'react';
import { Input } from '@availity/form';
import { Col, FormGroup, Row } from 'reactstrap';
import './SellerDocsInfoAddressInputFields.scss';
import { LocationStateItem } from '../../../utils/locationsHelper';
import { NotificationFlag } from '../../NotificationFlag/NotificationFlag';

export interface SellerDocsInfoAddressInputFieldsProps {
    fieldPrefix: string;
    stateOptions: LocationStateItem[];
    title?: string;
    isEditable?: boolean;
    notificationFlagPrefix?: string;
}

const SellerDocsInfoAddressInputFields: React.FC<
    SellerDocsInfoAddressInputFieldsProps
> = ({ fieldPrefix, stateOptions, title, isEditable = true, notificationFlagPrefix }) => {
    const fieldBadge = (field: string) =>
        notificationFlagPrefix ? (
            <NotificationFlag
                flagClassName="notification-flag-wrapper"
                doNotRemove={true}
                eventCode={`${notificationFlagPrefix}.${field}`}
            />
        ) : null;

    return (
        <div className="seller-docs-info-address-input-fields">
            {title && (
                <div className="section-header">
                    <h3>{title}</h3>
                </div>
            )}

            <FormGroup>
                <Row className="horizontal-form-group">
                    <Col md={5} className="col-form-label" tag="label">
                        <span className="label-with-badge">Street Address{fieldBadge('StreetAddress')}</span>
                    </Col>
                    <Col md={7}>
                        <Input
                            name={`${fieldPrefix}.streetAddress`}
                            type="text"
                            className="form-control"
                            disabled={!isEditable}
                        />
                    </Col>
                </Row>
            </FormGroup>

            <FormGroup>
                <Row className="horizontal-form-group">
                    <Col md={5} className="col-form-label" tag="label">
                        <span className="label-with-badge">City{fieldBadge('City')}</span>
                    </Col>
                    <Col md={7}>
                        <Input
                            name={`${fieldPrefix}.city`}
                            type="text"
                            className="form-control"
                            disabled={!isEditable}
                        />
                    </Col>
                </Row>
            </FormGroup>

            <FormGroup>
                <Row className="horizontal-form-group">
                    <Col md={5} className="col-form-label" tag="label">
                        <span className="label-with-badge">State{fieldBadge('State')}</span>
                    </Col>
                    <Col md={7}>
                        <Input
                            name={`${fieldPrefix}.state`}
                            type="select"
                            className="form-control"
                            disabled={!isEditable}>
                            <option value="">Select State</option>
                            {stateOptions.map((state) => (
                                <option key={state.id} value={state.code}>
                                    {state.code}
                                </option>
                            ))}
                        </Input>
                    </Col>
                </Row>
            </FormGroup>

            <FormGroup>
                <Row className="horizontal-form-group">
                    <Col md={5} className="col-form-label" tag="label">
                        <span className="label-with-badge">ZIP{fieldBadge('ZipCode')}</span>
                    </Col>
                    <Col md={7}>
                        <Input
                            name={`${fieldPrefix}.zipCode`}
                            type="text"
                            className="form-control"
                            maxLength={5}
                            disabled={!isEditable}
                            minLength={5}
                            pattern="[0-9]{5}"
                        />
                    </Col>
                </Row>
            </FormGroup>
        </div>
    );
};

export default SellerDocsInfoAddressInputFields;
